// CEO 页面白名单（monday_user.id），须与 server CEO_USER_IDS 默认值一致（server/src/guard/allow-users.decorator.ts）
export const CEO_USER_IDS = ['972c2g2c', '549g3eae']

export const ROAS_PAYBACK_PATH = '/roas/payback'

export const isCeoUser = (id) => !!id && CEO_USER_IDS.includes(id)
